import React, { useState } from 'react';
import Box from '../Box/Box';
import { css } from 'styled-components';
import { VideoPlayIcon } from '../../icons/VideoPlayIcon';
import Image from '../Image/Image';
import BookingFormModal from '../BookingFormModal/BookingFormModal';
import { getYoutubeIframeTag } from '../../utils/getYoutubeIframeTag';

export const VideoThumbnail = ({
    video_embed_link,
    image,
    playIconSize = 126,
    enableVideo = true,
    inlineVideoMp4,
    inlineVideoWebm,
    ref,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <Box
                // width="fit-content"
                position="relative"
                userSelect="none"
                {...(video_embed_link?.url &&
                    enableVideo && {
                        cursor: 'pointer',
                        transition: 'transform 250ms ease',
                        onClick: () => setIsModalOpen(true),
                    })}
                // @ts-ignore
                css={
                    video_embed_link?.url &&
                    enableVideo &&
                    css`
                        &:active {
                            transform: scale(0.96);
                        }

                        &:hover {
                            svg {
                                transform: scale(1.15);
                            }
                        }
                    `
                }
            >
                {video_embed_link?.url && enableVideo && (
                    <Box
                        position="absolute"
                        zIndex={1}
                        width="100%"
                        height="100%"
                        backgroundColor="red"
                        display="grid"
                        placeContent="center"
                        background="linear-gradient(0deg,rgba(0,0,0,0.20) 0%,rgba(0,0,0,0.20) 100%),rgb(211 211 211 / 20%) -1.546px 0.692px / 100% 99.522% no-repeat"
                        boxShadow="lg"
                        borderRadius="sm"
                        userSelect="none"
                    >
                        <VideoPlayIcon
                            transition="all 350ms ease"
                            width={playIconSize}
                            height={playIconSize}
                        />
                    </Box>
                )}

                {inlineVideoWebm && inlineVideoMp4 ? (
                    <Box
                        as="video"
                        borderRadius="md"
                        width="100%"
                        height="auto"
                        loop
                        muted
                        playsInline
                        autoPlay
                        poster={image.gatsbyImageData.images.fallback.src}
                    >
                        <source src={inlineVideoWebm} type="video/webm" />
                        <source src={inlineVideoMp4} type="video/mp4" />
                    </Box>
                ) : (
                    <Image ref={ref} img={image} objectFit="cover" />
                )}
            </Box>
            {isModalOpen && (
                <BookingFormModal onClose={() => setIsModalOpen(false)}>
                    <BookingFormModal.FrameContainer
                        onClose={() => setIsModalOpen(false)}
                        dangerouslySetInnerHTML={{
                            __html: getYoutubeIframeTag(video_embed_link.url),
                        }}
                    />
                </BookingFormModal>
            )}
        </>
    );
};
